import apiUrl from '@/helpers/apiUrl';
import axios from 'axios';
import { ACCESSES } from '@/mixins/access';

export default {
    namespaced: true,

    state: {
        isUncompletedOrders: false,
    },

    getters: {
        needShowWarningUncompletedOrders(state, getters) {
            return state.isUncompletedOrders && getters.hasAccessForShowWarning;
        },

        hasAccessForShowWarning(state, getters, rootState, rootGetters) {
            return rootGetters.accesses.includes(ACCESSES.showLateOrdersNotify);
        },
    },

    mutations: {
        setWarningStatus(state, value) {
            state.isUncompletedOrders = value;
        },
    },

    actions: {
        async checkUncompletedOrders({ commit, getters }) {
            if (!getters.hasAccessForShowWarning) {
                return;
            }

            try {
                const { data } = await axios.get(apiUrl.orders.lateOrdersNotification);
                commit('setWarningStatus', !!data?.lateOrdersNotification);
            } catch {
                commit('setWarningStatus', false);
            }
        },
    },
};